import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useIntl } from "react-intl";

import { RssiSettingsValue } from "./types";
import useEditedStyles from "../../../../hooks/useEditedStyles";
import { TemplateItemProps } from "../types";
import TimeTextField from "../TimeTextField";
import TitledCard from "../TitledCard";
import ZoneEvent from "../zoneevent/ZoneEvent";
import { onNumberInputClick } from "../../../../utils/utils";

interface RssiSettingsProps extends TemplateItemProps<RssiSettingsValue> {}

const RssiSettings = ({ value, saved, onChange, disabled }: RssiSettingsProps) => {
  const [delay, setDelay] = useState(`${value.delay}`);
  const [events, setEvents] = useState({ alarm: value?.e || "" });

  const { formatMessage } = useIntl();
  const editedStyle = useEditedStyles();

  useEffect(() => {
    setDelay(`${value.delay}`);
    setEvents({ alarm: value?.e || "" });
  }, [value]);

  return (
    <TitledCard title={formatMessage({ defaultMessage: "Signal strength" })}>
      <Grid container spacing={1} padding={1}>
        <Grid item>
          <TimeTextField
            label={formatMessage({ defaultMessage: "Delay" })}
            unit={1000}
            variant="filled"
            value={delay}
            className={saved?.delay !== parseInt(delay, 10) ? editedStyle.input : ""}
            inputProps={{ min: 0, type: "number", onClick: onNumberInputClick }}
            onChange={(e) => setDelay(e.target.value)}
            onBlur={() => {
              value.delay = delay ? parseInt(delay, 10) : 0;
              onChange(value);
            }}
            sx={{ minWidth: 220, width: 220, margin: 0 }}
            size="small"
            autoComplete="off"
            disabled={disabled}
          />
        </Grid>
        <ZoneEvent
          label={formatMessage({ defaultMessage: "Event" })}
          value={events}
          saved={saved ? { alarm: saved.e || "" } : undefined}
          onChange={({ alarm }) => {
            setEvents({ alarm });
            value.e = alarm;
            onChange(value);
          }}
          disabled={disabled}
          xs="auto"
          noRecovery
        />
      </Grid>
    </TitledCard>
  );
};

export default RssiSettings;
